import React, { useState } from 'react';
import { Link, useHistory } from "react-router-dom";
import { auth } from "./firebase";
import logo from './logo.png';
import { Form, Input, Button, Typography, Checkbox, Row, Col, Alert } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

function Copyright(props) {
  return (
    <Text type="secondary" style={{ display: 'block', textAlign: 'center', marginTop: '40px' }} {...props}>
      Created by Ghilas Belkaci.
    </Text>
  );
}

export default function SignUp() {
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const onFinish = (values) => {
        setLoading(true);
        setError('');
        
        if (!values.agreement) {
          setError('Please agree to the terms and conditions to proceed.');
          setLoading(false);
          return;
        }

        auth
            .createUserWithEmailAndPassword(values.email, values.password)
            .then((auth) => {
                if (auth) {
                    history.push('/');
                }
            })
            .catch(error => {
                setError(error.message);
                setLoading(false);
            });
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', minHeight: '100vh', paddingTop: '80px', background: 'var(--bg-layout)' }}>
            <Link to="/" style={{ marginBottom: '40px' }}>
                <img className="header__logo" src={logo} alt="Vectacore Logo" style={{ height: '40px', objectFit: 'contain' }} />
            </Link>
            
            <div style={{ width: '100%', maxWidth: '400px', background: 'var(--bg-glass)', padding: '40px', borderRadius: '8px', border: '1px solid var(--border-glass)', boxShadow: '0 4px 15px rgba(0,0,0,0.05)' }}>
                <Title level={3} style={{ textAlign: 'center', marginBottom: '24px' }}>
                    Sign Up
                </Title>
                
                {error && <Alert message={error} type="error" showIcon style={{ marginBottom: '24px' }} />}
                
                <Form
                    name="normal_signup"
                    className="signup-form"
                    layout="vertical"
                    onFinish={onFinish}
                >
                    <Form.Item
                        name="email"
                        rules={[{ required: true, message: 'Please input your Email!' }]}
                    >
                        <Input 
                            prefix={<UserOutlined className="site-form-item-icon" />} 
                            placeholder="Email Address" 
                            size="large" 
                        />
                    </Form.Item>
                    
                    <Form.Item
                        name="password"
                        rules={[{ required: true, message: 'Please input your Password!' }]}
                    >
                        <Input.Password
                            prefix={<LockOutlined className="site-form-item-icon" />}
                            type="password"
                            placeholder="Password"
                            size="large"
                        />
                    </Form.Item>
                    
                    <Form.Item
                        name="agreement"
                        valuePropName="checked"
                        rules={[
                          { validator: (_, value) => value ? Promise.resolve() : Promise.reject(new Error('Should accept agreement')) },
                        ]}
                    >
                        <Checkbox>
                             By signing-in you agree to the Conditions of Use & Sale. 
                             Please see our Privacy Notice.
                        </Checkbox>
                    </Form.Item>

                    <Form.Item>
                        <Button type="primary" htmlType="submit" className="signup-form-button" block size="large" loading={loading}>
                            Sign Up
                        </Button>
                    </Form.Item>
                    
                    <Row style={{ marginTop: '16px', textAlign: 'center' }}>
                        <Col span={24}>
                            <Link to="/login">
                                Already have an account? Sign in
                            </Link>
                        </Col>
                    </Row>
                </Form>
            </div>
            
            <Copyright />
        </div>
    );
}